import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalService {

    constructor() {
    }
    
    /**
     * 格式化时间
     * @param type 格式化类型yyyy-MM-dd HH:mm:ss，注意MM为月份、mm为分钟
     * @param time 可选。默认当前时间
     * @returns yyyy-MM-dd HH:mm:ss
     */
    formatDate(type: string, time?: any): string {
        if (!time) {
            time = new Date();
        } else {
            time = new Date(time);
        }
        if (!type) {
            return '';
        }
        const year = time.getFullYear();
        const month = (time.getMonth() + 1).toString().padStart(2, '0');
        const date = (time.getDate()).toString().padStart(2, '0');
        const hours = (time.getHours()).toString().padStart(2, '0');
        const minute = (time.getMinutes()).toString().padStart(2, '0');
        const second = (time.getSeconds()).toString().padStart(2, '0');

        return type.replace('yyyy', year).replace('MM', month).replace('dd', date).replace('HH', hours).replace('mm', minute).replace('ss', second);
    }

    /**
     * 获取文件后缀
     * @param filename string 文件名
     * @returns extension
     */
    getFileExtension(filename: string): string {
        if (!filename) {
            return '';
        }
        const filenameArr = filename.split('.');
        if (filenameArr.length == 0) {
            return '';
        } else {
            const extension = filenameArr.pop()!;
            return extension.toLowerCase();
        }
    }
}

